/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEvent,
    JsonEventFromJSON,
    JsonEventFromJSONTyped,
    JsonEventToJSON,
} from './JsonEvent';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEvent
 */
export interface ApiResultOfJsonEvent {
    /**
     * 
     * @type {JsonEvent}
     * @memberof ApiResultOfJsonEvent
     */
    data?: JsonEvent;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEvent
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEvent
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEvent
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEvent
     */
    result?: ApiResultOfJsonEventResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventFromJSON(json: any): ApiResultOfJsonEvent {
    return ApiResultOfJsonEventFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventToJSON(value?: ApiResultOfJsonEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

